// Configuration file for API endpoints
const config = {
  // Development environment (local)
  development: {
    apiBaseUrl: 'http://localhost:8001'
  },
  // Production environment (AWS Elastic Beanstalk)
  production: {
    apiBaseUrl: 'https://d1mp84rwpv9xfe.cloudfront.net'
  }
};

// Set the current environment based on the hostname
const isProduction = 
  window.location.hostname !== 'localhost' && 
  window.location.hostname !== '127.0.0.1';

// Export the appropriate configuration
const currentConfig = isProduction ? config.production : config.development;

export default currentConfig;
